'use es6';

import PortalIdParser from 'PortalIdParser';
import userInfo from 'hub-http/userInfo';
import Raven from 'raven-js';
import * as ActionTypes from './ActionTypes';
import { getHub } from '../clients/hubsClient';
export const getAuth = () => dispatch => {
  PortalIdParser.get();
  return userInfo().then(({
    user,
    gates,
    portal
  }) => {
    Raven.setUserContext({
      id: user.user_id,
      email: user.email,
      locale: user.locale
    });
    dispatch({
      type: ActionTypes.INITIALIZE_AUTH,
      user,
      gates,
      portal
    });
  });
};
export const getHubScopes = () => dispatch => {
  dispatch({
    type: ActionTypes.HUB_FETCH_REQUESTED
  });
  return getHub().then(({
    scopeLimitInfo: {
      scopes
    }
  }) => {
    dispatch({
      type: ActionTypes.HUB_FETCH_RECEIVED,
      payload: scopes
    });
  }).catch(err => {
    dispatch({
      type: ActionTypes.HUB_FETCH_FAILED,
      payload: err
    });
  });
};